import { StudentSectionSettingTypeCodes } from 'const';
import { creationWidgetVisibilityHooks } from 'hooks';
import {
  creationClubsSelector,
  creationContestsSelector,
  creationOccupationsSelector,
  creationRewardsSelector,
} from 'selectors';
import { getDataLoadRequests } from 'utils';

import { SectionLoaderConfig } from './types';

export const getCreationLoaderConfig = (): SectionLoaderConfig => {
  return [
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.creationReward,
      requests: getDataLoadRequests().creationRewards,
      loadingSelector: creationRewardsSelector,
      dataSelector: (state) => creationRewardsSelector(state).content.length > 0,
      useWidgetVisibility: creationWidgetVisibilityHooks.useRewards,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.creationClub,
      requests: getDataLoadRequests().creationClubs,
      loadingSelector: creationClubsSelector,
      dataSelector: (state) => creationClubsSelector(state).content.length > 0,
      useWidgetVisibility: creationWidgetVisibilityHooks.useClubs,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.creationContest,
      requests: getDataLoadRequests().creationContests,
      loadingSelector: creationContestsSelector,
      dataSelector: (state) => creationContestsSelector(state).content.length > 0,
      useWidgetVisibility: creationWidgetVisibilityHooks.useContests,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.creationUnit,
      requests: getDataLoadRequests().creationSections,
      loadingSelector: creationOccupationsSelector,
      dataSelector: (state) => creationOccupationsSelector(state).content.length > 0,
      useWidgetVisibility: creationWidgetVisibilityHooks.useSections,
    },
  ];
};
